import {
  GET_BUYERS_ITEMS_AND_PRODUCTS,
  GET_BUYERS_ITEMS_AND_PRODUCTS_ERROR,
  GET_BUYERS_ITEMS_AND_PRODUCTS_SUCCESS
} from './BuyersByItemsAndProductsSection.actions'

const buyersByItemsAndProductsSectionState = {
  buyers: [],
  error: null,
  loading: false
}

/**
 * The buyers by items and products section's reducer.
 */
const buyersByItemsAndProductsSectionReducer = (state = buyersByItemsAndProductsSectionState, { payload, type }) => {
  switch (type) {
    case GET_BUYERS_ITEMS_AND_PRODUCTS: {
      return { ...state, loading: true }
    }
    case GET_BUYERS_ITEMS_AND_PRODUCTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_BUYERS_ITEMS_AND_PRODUCTS_SUCCESS: {
      return { ...state, buyers: payload.buyers, loading: false }
    }
    default: {
      return state
    }
  }
}

export default buyersByItemsAndProductsSectionReducer
